import { OverlayPortal } from '../ModalPortal'
import { OrellaSpinner } from '../OrellaLoader' // s123: the app's one spinner

/**
 * SwitchDoctorSheet — s99 D476 (Dr. Rami 2026-10-10, "Orella Switch Doctor" mockup, approved).
 *
 * ★ ONE LIVE SHARE AT A TIME. Every path that starts a new share while one is live asks here
 *   first, and confirming withdraws the case (utils/withdrawCase.js): the old office loses
 *   access, the share code dies, the server reopens the answers. Used by the share hub ("Send
 *   to a different office", "Need a Doctor?" after a send) and the Diagnose screen ("Cancel &
 *   share with another doctor"). The copy is the caller's; the shape is one.
 */
export default function SwitchDoctorSheet({ open, title, body1, body2, confirmLabel, keepLabel, busy, onConfirm, onClose, testId }) {
  if (!open) return null
  const close = () => { if (!busy) onClose && onClose() }
  return (
    <OverlayPortal>
      <div className="fixed inset-0 z-50 flex items-end" style={{ background: 'rgba(21,53,79,.45)', animation: 'shareSheetFade 0.18s ease-out' }}
           onClick={(e) => { if (e.target === e.currentTarget) close() }}>
        <div className="w-full bg-white rounded-t-3xl px-5 pt-3.5 flex flex-col gap-2.5" data-testid={testId || 'switch-doctor-sheet'}
             style={{ animation: 'shareSheetRise 0.26s cubic-bezier(0.2, 0.8, 0.2, 1)', paddingBottom: 'calc(1.75rem + env(safe-area-inset-bottom, 0px))' }}>
          <span className="mx-auto mb-1 rounded" style={{ width: 32, height: 3, background: '#E2E8F0' }} />
          <b className="text-[16.5px]" style={{ color: '#15354F' }}>{title}</b>
          {body1 ? <p className="text-[13.5px] leading-snug m-0" style={{ color: '#5A7185' }}>{body1}</p> : null}
          {body2 ? <p className="text-[13.5px] leading-snug m-0" style={{ color: '#5A7185' }}>{body2}</p> : null}
          <button type="button" onClick={onConfirm} disabled={busy} data-cta="switch-doctor-confirm"
                  className="mt-1 h-[48px] rounded-full font-bold text-[14.5px] text-white flex items-center justify-center gap-2 disabled:opacity-70"
                  style={{ background: '#15354F' }}>
            {busy ? <OrellaSpinner size={16} tone="inherit" /> : null}
            {confirmLabel}
          </button>
          <button type="button" onClick={close} disabled={busy}
                  className="self-center text-[13.5px] font-bold py-1.5" style={{ color: '#46A8F9' }}>
            {keepLabel}
          </button>
        </div>
      </div>
    </OverlayPortal>
  )
}
